import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useFetch from "../../../hooks/useFetch";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

const TABS = [
  { key: "STICKY", label: "Sticky" },
  { key: "ALL", label: "All" },
  { key: "DIGIBOUTIQUE", label: "DigiBoutique" },
  { key: "PRODUCT", label: "Product" },
  { key: "PARENT", label: "Parent" },
  { key: "MENTOR", label: "Mentor" },
  { key: "INFLUENCER", label: "Influencer" },
  { key: "MERCHANT", label: "Merchant" },
  { key: "HUSTLES", label: "Hustles" },
  { key: "FEATURES", label: "Features" },
];

const PDUpdates = () => {
  const authState = useSelector((state) => state.authReducer);
  const [fetchData] = useFetch();
  const userCode = authState.think5whyscode || "";

  const [activeTab, setActiveTab] = useState("STICKY");
  const [dataCache, setDataCache] = useState({
    STICKY: [],
    TODAY: [],
    WEEK: [],
    MONTH: [],
  });

  const [expanded, setExpanded] = useState({});

  const fetchUpdates = async (tab) => {
    if (dataCache[tab]?.length > 0) return;

    try {
      const res = await fetchData({
        url: "/pd/updates/list",
        method: "post",
        data: { tab },
        headers: { Authorization: authState.token },
      });

      if (res?.status) {
        setDataCache((prev) => ({
          ...prev,
          [tab]: res.records || [],
        }));
      }
    } catch (err) {
      console.error("FETCH ERROR:", err?.response?.data || err.message || err);
    }
  };

  useEffect(() => {
    if (authState?.token && userCode) {
      fetchUpdates("STICKY");
    }
  }, [authState?.token, userCode]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    fetchUpdates(tab);
  };

  const toggleExpand = (id) => {
    setExpanded((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const renderList = () => {
    const list = dataCache[activeTab] || [];

    if (!list.length) {
      return (
        <div className="text-zinc-400 text-center mt-16 py-8 text-sm">
          No updates available
        </div>
      );
    }

    return list.map((item) => (
      <div
        key={item._id}
        className="bg-zinc-900 border border-zinc-800 rounded-3xl p-5 mb-4 shadow-xl hover:shadow-2xl transition-all duration-300 w-full"
      >
        <div className="flex justify-between items-center text-xs text-zinc-400 mb-3">
          <span>
            {item.postedBy || "Admin"} •{" "}
            {new Date(item.updateDate).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
            })}
          </span>

          <button
            onClick={() => toggleExpand(item._id)}
            className="w-fit px-2 py-1 hover:bg-zinc-800 rounded-2xl transition-colors"
          >
            <FontAwesomeIcon
              icon={expanded[item._id] ? faChevronUp : faChevronDown}
              className="text-zinc-400"
            />
          </button>
        </div>

        <div className="font-bold text-base lg:text-lg leading-tight text-white tracking-tight">
          {item.headline}
        </div>

        {expanded[item._id] && (
          <div className="text-sm mt-4 text-zinc-300 whitespace-pre-line leading-relaxed border-t border-zinc-800 pt-4">
            {item.details}
          </div>
        )}
      </div>
    ));
  };

  return (
    <div className="fle-1 w-full bg-zinc-950 text-white min-h-screen pb-8">
      <div className="bg-zinc-950 border-b border-zinc-800">
        <div className="px-4 pt-6 pb-3">
          <h1 className="text-lg lg:text-xl font-black tracking-tighter bg-gradient-to-r from-cyan-400 to-cyan-600 bg-clip-text text-transparent">
            Think5Whys & PurpleDoor UPDATES
          </h1>
          <p className="text-zinc-500 text-xs lg:text-sm mt-1">Stay in the loop</p>
        </div>

        <div className="px-4 pb-4">
          <div className="grid grid-cols-5 lg:grid-cols-10 gap-0.5">
            {TABS.map((tab) => (
              <button
                key={tab.key}
                onClick={() => handleTabChange(tab.key)}
                className={`
                  w-fit py-1 px-2 rounded-md text-xs lg:text-sm leading-none
                  border active:scale-[0.97] transition-all duration-200
                  ${
                    activeTab === tab.key
                      ? "bg-violet-600 border-violet-500 text-white shadow-lg shadow-violet-500/30"
                      : "bg-zinc-900 border-zinc-700 text-zinc-400 hover:bg-zinc-800 hover:border-zinc-600"
                  }
                `}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Content - Full width with consistent padding */}
      <div className="px-4 pt-2">
        {renderList()}
      </div>
    </div>
  );
};

export default PDUpdates;